import HBModal, { type HBModalProps } from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";

function HBModalConfirm({
  content,
  tracker,
  ...props
}: {
  content: React.ReactNode;
  tracker?: Record<string, any>;
} & HBModalProps) {
  return (
    <HBModal cancelButtonProps={{ style: { display: "none" } }} {...props}>
      <div {...tracker}>{content}</div>
    </HBModal>
  );
}

export default ModalWrap(HBModalConfirm);
